const PARTNER_TAG = Object.freeze({
  FFV: 'ffv_license',
});

export default PARTNER_TAG;
